import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=2250e9bd&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=2250e9bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250e9bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2250e9bd')) {
      api.createRecord('2250e9bd', component.options)
    } else {
      api.reload('2250e9bd', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=2250e9bd&scoped=true&", function () {
      api.rerender('2250e9bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26K0aBrqqIhnN/JS/comp/PopupBox.vue"
export default component.exports